var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row q-col-gutter-sm" }, [
    _c(
      "div",
      { staticClass: "col-12 col-sm-6 col-md-3 col-lg" },
      [
        _c("q-select", {
          attrs: {
            label: _vm.$t("label.color"),
            options: _vm.colorsWithEmptyValue,
            "option-value": "uid",
            "option-label": "value",
            loading: _vm.loadingSpeciesFilters,
            "map-options": "",
            "emit-value": ""
          },
          model: {
            value: _vm.color,
            callback: function($$v) {
              _vm.color = $$v
            },
            expression: "color"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 col-sm-6 col-md-3 col-lg" },
      [
        _c("q-select", {
          attrs: {
            label: _vm.$t("label.application"),
            options: _vm.applicationsWithEmptyValue,
            "option-value": "uid",
            "option-label": "value",
            loading: _vm.loadingSpeciesFilters,
            "map-options": "",
            "emit-value": ""
          },
          model: {
            value: _vm.application,
            callback: function($$v) {
              _vm.application = $$v
            },
            expression: "application"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 col-sm-6 col-md-3 col-lg" },
      [
        _c("q-field", {
          attrs: {
            label: _vm.$t("label.availability"),
            "stack-label": "",
            borderless: ""
          },
          scopedSlots: _vm._u([
            {
              key: "control",
              fn: function() {
                return _vm._l([1, 2, 3, 4], function(value) {
                  return _c("q-checkbox", {
                    key: value,
                    attrs: { val: value },
                    model: {
                      value: _vm.availability,
                      callback: function($$v) {
                        _vm.availability = $$v
                      },
                      expression: "availability"
                    }
                  })
                })
              },
              proxy: true
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 col-sm-6 col-md-3 col-lg" },
      [
        _c("q-field", {
          attrs: {
            label: _vm.$t("label.pricegroup"),
            "stack-label": "",
            borderless: ""
          },
          scopedSlots: _vm._u([
            {
              key: "control",
              fn: function() {
                return _vm._l([1, 2, 3, 4], function(value) {
                  return _c("q-checkbox", {
                    key: value,
                    attrs: { val: value },
                    model: {
                      value: _vm.pricegroup,
                      callback: function($$v) {
                        _vm.pricegroup = $$v
                      },
                      expression: "pricegroup"
                    }
                  })
                })
              },
              proxy: true
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-6 col-sm-6 col-md-3 col-lg" },
      [
        _c(
          "q-field",
          {
            attrs: {
              label: _vm.$t("label.fsc"),
              "stack-label": "",
              borderless: ""
            }
          },
          [
            _c("q-checkbox", {
              attrs: { type: "checkbox" },
              model: {
                value: _vm.fsc,
                callback: function($$v) {
                  _vm.fsc = $$v
                },
                expression: "fsc"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-6 col-sm-6 col-md-3 col-lg" },
      [
        _c(
          "q-field",
          {
            attrs: {
              label: _vm.$t("label.pefc"),
              "stack-label": "",
              borderless: ""
            }
          },
          [
            _c("q-checkbox", {
              attrs: { type: "checkbox" },
              model: {
                value: _vm.pefc,
                callback: function($$v) {
                  _vm.pefc = $$v
                },
                expression: "pefc"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 col-sm-6 col-md-3 col-lg" },
      [
        _c("q-select", {
          attrs: {
            label: _vm.$t("label.occurrence"),
            options: _vm.occurencesWithEmptyValue,
            "option-value": "uid",
            "option-label": "value",
            loading: _vm.loadingSpeciesFilters,
            "map-options": "",
            "emit-value": ""
          },
          model: {
            value: _vm.occurrence,
            callback: function($$v) {
              _vm.occurrence = $$v
            },
            expression: "occurrence"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }